import { Box, IconButton, Tooltip } from '@mui/material';
import { Add, FilterAltOff, Search } from '@mui/icons-material';
import {
  CustomAutoComplete,
  CustomButton,
  CustomTextField,
  HorizontalForm,
  InfoTooltip,
} from '../../../common/components';
import { AUTOCOMPLETE_LISTBOX_PROPS } from '../../../common/styles';
import { toProjectOptions } from '../../utils/toProjectOptions';
import {
  RETURN_ACTION_SX,
  RETURN_FILTER_SX,
  RETURN_TEXTS as TEXTS,
} from '../constants/consumptionReturnTexts';

/** Acciones y filtros alineados, con espacio propio para la autorización. */
const ConsumptionReturnsToolbar = ({
  canAuthorize,
  onCreate,
  search,
  onSearch,
  filters,
  onFilter,
  onClear,
  projects,
}) => (
  <HorizontalForm
    withBorder={false}
    sx={{
      px: 2.5,
      py: 1.5,
      gap: 1.5,
      alignItems: 'center',
      flexWrap: { xs: 'wrap', lg: 'nowrap' },
    }}
  >
    {canAuthorize && (
      <CustomButton variant="base" startIcon={<Add />} onClick={onCreate} sx={RETURN_ACTION_SX}>
        {TEXTS.create}
      </CustomButton>
    )}
    <CustomTextField
      label={TEXTS.search}
      value={search}
      onChange={(event) => onSearch(event.target.value)}
      sx={RETURN_FILTER_SX}
      InputProps={{ startAdornment: <Search sx={{ color: 'primary.main', mr: 1 }} /> }}
    />
    <CustomAutoComplete
      label={TEXTS.project}
      value={filters.uuid_project || ''}
      options={toProjectOptions(projects)}
      inputPlaceholder={TEXTS.project}
      ListboxProps={AUTOCOMPLETE_LISTBOX_PROPS}
      onChange={(event) => onFilter('uuid_project', event.target.value)}
      sx={RETURN_FILTER_SX}
    />
    <CustomAutoComplete
      label={TEXTS.status}
      value={filters.status || ''}
      options={TEXTS.statuses}
      onChange={(event) => onFilter('status', event.target.value)}
      sx={{ ...RETURN_FILTER_SX, flex: '0 1 240px', minWidth: 200 }}
    />
    <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
      <Tooltip title={TEXTS.clear}>
        <IconButton color="primary" onClick={onClear} aria-label={TEXTS.clear}>
          <FilterAltOff />
        </IconButton>
      </Tooltip>
      <InfoTooltip lines={[TEXTS.info]} />
    </Box>
  </HorizontalForm>
);

export default ConsumptionReturnsToolbar;
